import { connect } from '@lumapps/redux/react';

import { mapLoadingStateToProps } from '../../../utils/mapLoadingStateToProps';
import { BlockGrid } from './BlockGrid';

export const ConnectedBlockGrid = connect(mapLoadingStateToProps, null)(BlockGrid);
export { ConnectedBlockGrid as BlockGrid };
